// Include the MathJax script directly for rendering LaTeX.
export const loadMathJaxScript = () => {
    if (document.querySelector("#mathjax-script")) {
        return;
    }

    const script = document.createElement("script");
    script.id = "mathjax-script";
    script.src =
        "https://cdnjs.cloudflare.com/ajax/libs/mathjax/2.7.5/MathJax.js?config=TeX-AMS_HTML";
    script.async = true;
    document.head.appendChild(script);

    script.onload = () => {
        if (window.MathJax && window.MathJax.Hub) {
            window.MathJax.Hub.Config({
                tex2jax: {
                    inlineMath: [
                        ["$", "$"],
                        ["\\(", "\\)"],
                    ],
                },
                skipStartupTypeset: true,
                messageStyle: "none",
            });
            window.MathJax.Hub.Queue(["Typeset", window.MathJax.Hub]);
        }
    };
};
